import React from "react";
import { ProductGalleryWidget } from './widgets/ProductGalleryWidget';
import { InventorySection } from './widgets/InventorySection';
import { ProductDetailsSection } from './widgets/ProductDetailsSection';
import { PricingCard } from './widgets/PricingCard';
import { StorefrontSection } from './widgets/StorefrontSection';
import { ItemCollectionsSection } from './widgets/ItemCollectionsSection';
import { AdvancedSection } from './widgets/AdvancedSection';
import { DisabledBanner } from './widgets/DisabledBanner';
import { MarketplaceListingsSection } from './widgets/MarketplaceListingsSection';
import { BookingSection } from './widgets/BookingSection';
import { ProductDocumentsWidget } from './widgets/ProductDocumentsWidget';
import { GenericSection } from '../sales-order';
import type { ShopifySectionWidgetProps } from './types';

// Export all widgets
export {
  ProductGalleryWidget,
  InventorySection,
  ProductDetailsSection,
  PricingCard,
  StorefrontSection,
  ItemCollectionsSection,
  AdvancedSection,
  DisabledBanner,
  MarketplaceListingsSection,
  BookingSection,
  ProductDocumentsWidget,
  GenericSection,
};

// Legacy widget map — fallback for sections without widgetId in DocViewSchema.
// The primary routing uses EXPERIENCE_WIDGETS in registry.ts via _widgetId.
export const ITEM_WIDGETS: Record<string, React.ComponentType<ShopifySectionWidgetProps>> = {
  "item-overview": ProductGalleryWidget,
  "product-details": ProductDetailsSection,
  "pricing": PricingCard,
  "inventory": InventorySection,
  "storefront": StorefrontSection,
  "marketplace-listings": MarketplaceListingsSection,
  "booking": BookingSection,
  "documents": ProductDocumentsWidget,
  "collections": ItemCollectionsSection,
  "advanced": AdvancedSection,
  "disabled-banner": DisabledBanner,
};

// Re-export types
export type { ShopifySectionWidgetProps } from './types';


